import axios from 'axios';
import url from 'url';

import { setServiceURI } from '../../globals/serviceURI/serviceURI';
import { setVoiceToken } from '../../utils/voiceToken/voiceToken';

/**
 * @returns {Promise<string>}
 */
export default async (user, domain) => {
  const token = global.localStorage.getItem('ns_t');

  if (!token) {
    throw Error('authenticate function requires a netsapiens local storage user token');
  }

  if (!user) {
    throw Error('Missing function param "user"');
  }

  if (!domain) {
    throw Error('Missing function param "domain"');
  }

  const { protocol, hostname } = url.parse(global.location.href);

  const { data } = await axios.request({
    method: 'post',
    withCredentials: true,
    url: `${protocol}//${hostname}/ns-api/voice/token`,
    headers: {
      Authorization: `Bearer ${token}`,
      AsDomain: domain,
    },
    params: {
      domain,
      user,
    },
  });

  if (!data || !data.token) {
    throw Error('error getting voice token');
  }

  setServiceURI(data.serviceBaseUri);
  setVoiceToken(data.token);

  return data.token;
};
